import { HomePath } from "./homeTypes";

// Lazy load paths to prevent circular dependencies in production builds
let cachedHomePaths: HomePath | null = null;

async function loadHomePaths(): Promise<HomePath> {
  if (cachedHomePaths) {
    return cachedHomePaths;
  }

  const { nursePaths } = await import("@/app/nurse/routes/nursePaths");
  const { financePaths } = await import("@/app/finance/routes/financePaths");
  const { clinicalPaths } = await import("@/app/clinical/routes/clinicalPaths");
  const { reportPaths } = await import("@/app/reports/common/routes/reportPaths");
  const { radiologyPaths } = await import("@/app/radiology/routes/radiologyPaths");
  const { integrationPaths } = await import("@/app/integrations/routes/integrationPaths");
  const { registrationPaths } = await import("@/app/registration/routes/registrationPaths");
  const { theatrePaths } = await import("@/app/theatre/routes/theatrePaths");
  const { doctorPaths } = await import("@/app/doctors/routes/doctorPaths");
  const { inventoryPaths } = await import("@/app/inventory/routes/inventoryPaths");

  cachedHomePaths = {
    ...registrationPaths,
    ...doctorPaths,
    ...inventoryPaths,
    ...theatrePaths,
    ...financePaths,
    ...clinicalPaths,
    ...nursePaths,
    ...radiologyPaths,
    ...reportPaths,
    ...integrationPaths,

    doctors: { path: "/doctors", title: "Doctor", tag: "doctors" },
    pharmacy: { path: "/pharmacy", title: "Pharmacy", tag: "pharmacy" },
    laboratory: { path: "/laboratory", title: "Laboratory", tag: "laboratory" },
    theatre: { path: "/theatre", title: "Theatre", tag: "theatre" },
    dental: { path: "/dental", title: "Dental", tag: "dental" },
    cardiology: { path: "/cardiology", title: "Cardiology", tag: "cardiology" },
    optical: { path: "/optical", title: "Optical", tag: "optical" },
    inventory: { path: "/inventory", title: "Inventory", tag: "inventory" },
  };

  return cachedHomePaths;
}

export { loadHomePaths };

export const getHomePaths = (): Promise<HomePath> => loadHomePaths();

// Export a synchronous getter for backward compatibility (empty initially, populated on first async load)
export const homePaths: HomePath = {} as HomePath;

export const getTitleByPath = (path: string) => {
  const item = Object.values(homePaths).find((item) => item.path === path);
  return item ? item.title : "";
};
